import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const subscriptionList = (params = '') => {
	const query = serialize(params)
	return Http.get(`/admin/subscriptions${query}`)
}

export const subscriptionStats = () => Http.get('/admin/subscriptions/stats')

export const subscriptionCreate = data => Http.post('/admin/subscriptions', data)

export const subscriptionBulkCreate = data => Http.post('/admin/subscriptions/bulk', data)

export const subscriptionUpgrade = (id, data) => Http.post(`/admin/subscriptions/${id}/upgrade`, data)

export const subscriptionCancel = (id, data) => Http.post(`/admin/subscriptions/${id}/cancel`, data)

export const subscriptionCancellations = (params = '') => {
	const query = serialize(params)
	return Http.get(`/admin/subscriptions/cancellations${query}`)
}
